import { makeStyles } from "@material-ui/core/styles";

const theme = (props) => {
  const styles = makeStyles(theme => ({
    backdrop: { zIndex: 1300 },
    circle: {
      color: props.color2
    },
  }));
  return styles();
}
export default theme;

